import Swiper from 'swiper'
import { merge } from 'lodash-es'

import { select } from '@js/util/select.js'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus.js'

select('.wpce-swiper.item-swiper', swiperElement => {
  const options = merge(
    {
      // Optional parameters
      direction: 'horizontal',
      loop: false,
      autoHeight: true,
      slidesPerView: 1.2,
      spaceBetween: 22,

      // Don't set threshold to 0 as this can cause scrolling issues in iOS
      threshold: 15,

      // If we need pagination
      breakpoints: {
        540: {
          slidesPerView: 2.2,
          spaceBetween: 22,
        },
        1021: {
          slidesPerView: 3.2,
          spaceBetween: 60,
        },
        1600: {
          slidesPerView: 3,
          spaceBetween: 92,
        },
      },
    },
    JSON.parse(swiperElement.dataset.swiperOptions),
  )

  const swiper = new Swiper(`#${swiperElement.dataset.swiperId}`, options)

  if (swiperElement.dataset.swiperSlide) {
    swiper.slideTo(Number(swiperElement.dataset.swiperSlide))
  }

  // Keyboard focus is not handled by Swiper.js itself
  swiperHandleKeyboardFocus(swiper)

  // Handle previous button
  function onPrevClick() {
    swiper.slideTo(swiper.activeIndex - 1)
  }
  const prevButton = swiperElement.querySelector('.custom-button-prev')
  prevButton?.addEventListener('click', onPrevClick)

  // Handle next button
  function onNextClick() {
    swiper.slideTo(swiper.activeIndex + 1)
  }
  const nextButton = swiperElement.querySelector('.custom-button-next')
  nextButton?.addEventListener('click', onNextClick)

  function applyBeginningEndClasses() {
    prevButton.disabled = swiper.isBeginning
    nextButton.disabled = swiper.isEnd
  }
  swiper.on('slideChange', applyBeginningEndClasses)
  swiper.on('resize', applyBeginningEndClasses)
  applyBeginningEndClasses()

  // Handle swiper destroy
  swiper.once('beforeDestroy', () => {
    prevButton?.removeEventListener('click', onPrevClick)
    nextButton?.removeEventListener('click', onNextClick)
  })

  // Swiper will add the 'swiper-slide-visible' to all visible slides, even those which are only partly visible
  // The 'determineEdgeSlides' inspects all slides and finds the ones that are only partly visible
  function determineEdgeSlides() {
    const currentBreakpoint = swiper.currentBreakpoint
    const activeIndex = swiper.activeIndex
    const currentSlidesPerView = Math.floor(
      options.breakpoints[currentBreakpoint]?.slidesPerView ?? options.slidesPerView ?? 1,
    )
    swiper.slides.forEach((slide, index, slides) => {
      const isEdge = index < activeIndex || index >= activeIndex + currentSlidesPerView
      slide.classList.toggle('edge-slide', isEdge)
    })
  }

  determineEdgeSlides()

  swiper.on('transitionStart', determineEdgeSlides)
  swiper.on('resize', determineEdgeSlides)
  swiper.on('touchStart', () => {
    swiperElement.classList.add('no-edges')
  })
  swiper.on('touchEnd', () => {
    swiperElement.classList.remove('no-edges')
  })

  return () => {
    swiper.destroy()
  }
})
